import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  inputHidden: {
    borderWidth: 0,
  },
}))

export default styles
